<template>
  <div class="box4">
    <pageTitle
      title="选择AI &nbsp;0基础课程带你轻松入行"
      text="课程设置科学合理，解决入门问题，适合AI初学者"
    />

    <div class="subject-content">
      <div class="top-box">
        <div class="text-box">
          <div class="title">AI入门难？</div>
          <p>
            设置基础
            <br />入门课程
          </p>
        </div>

        <div class="text-box">
          <div class="title">知识学习难？</div>
          <p>
            知识难点
            <br />细分讲解
          </p>
        </div>

        <div class="text-box">
          <div class="title">技能精通难？</div>
          <p>
            理论与实践
            <br />相结合
          </p>
        </div>
      </div>
      <div class="btm-box">
        <div class="lable">如果你是这些人群，学完就业没问题</div>
        <div class="line-box"></div>
        <div class="demo-box">
          <div class="demo" v-for="(item, index) in list" :key="index">
            <div class="title">
              <img
                :src="
                  require(`../../../assets/coursePage/ai/box4/icon${
                    index + 1
                  }.png`)
                "
                alt
              />
              {{ item.title }}
            </div>
            <p v-html="item.p"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      list: [
        {
          title: "刚毕业",
          p: "选择前景广阔<br />的职业方向",
        },
        {
          title: "无基础",
          p: "自学困难<br />无法快速入行",
        },

        {
          title: "想转行",
          p: "重新择业<br />没有目标",
        },
        {
          title: "爱钻研",
          p: "热爱人工智能<br />喜欢研究新技术",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box4 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/ai/box3/box3-bg.png") no-repeat;
  background-size: cover;

  .subject-content {
    // position: relative;
    margin-top: 48px;

    .top-box {
      display: flex;
      flex: 1;
      justify-content: space-between;
      margin: 0 auto;
      padding: 0 56px;
      padding-top: 32px;
      width: 654px;
      height: 288px;
      background: linear-gradient(
        315deg,
        #59cbff 0%,
        #73d3ff 52%,
        #3cb2e8 100%
      );
      border-radius: 24px;
      box-sizing: border-box;

      .text-box {
        font-family: PingFang-SC-Medium;
        .title {
          position: relative;
          margin-bottom: 40px;
          font-family: PingFangSC-Medium;
          font-size: 24px;
          font-weight: 500;
          color: #ffffff;
          text-align: center;
          line-height: 34px;

          &::after {
            position: absolute;
            bottom: -32px;
            left: 50%;
            transform: translate(-50%, 0);
            content: "";
            width: 16px;
            height: 24px;
            background: url("../../../assets/coursePage/ai/box4/icon.png")
              no-repeat;
            background-size: cover;
          }
        }
        p {
          font-size: 28px;
          font-weight: 600;
          color: #ffffff;
          // text-align: center;
          line-height: 44px;
        }
        &:nth-child(2) {
          p {
            margin-left: 15px;
            // text-align: center;
          }
        }
        &:last-child {
          p {
            text-align: center;
          }
        }
      }
    }

    .btm-box {
      position: relative;
      margin: 0 auto;
      margin-top: -48px;
      width: 686px;
      height: 468px;
      background: #ffffff;
      box-shadow: 0px -4px 20px 0px rgba(81, 188, 235, 0.34);
      border-radius: 20px;
      border: 2px solid #ffffff;

      .line-box {
        position: absolute;
        top: 88px;
        left: 50%;
        transform: translate(-50%, 0px);
        width: 622px;
        height: 324px;
        background: url("../../../assets/coursePage/ai/box4/line.png") no-repeat;
        background-size: cover;
      }

      .lable {
        position: absolute;
        top: -52px;
        left: 50%;
        transform: translate(-50%, 0px);
        width: 530px;
        height: 108px;
        font-size: 28px;
        text-align: center;
        line-height: 108px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #1c3844;
        background: url("../../../assets/coursePage/ai/box4/lable.png")
          no-repeat;
        background-size: cover;
      }

      .demo-box {
        margin-top: 58px;
        display: flex;
        flex-wrap: wrap;
        .demo {
          padding-top: 32px;
          width: 342px;
          height: 204px;
          text-align: center;
          box-sizing: border-box;

          .title {
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              margin-right: 6px;
              width: 32px;
              height: 32px;
            }
            font-size: 28px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: #13b6ea;
            line-height: 44px;
          }
          p {
            margin-top: 16px;
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #1d2129;
            line-height: 40px;
          }
        }
      }
    }
  }
}
</style>
